import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";

const userAPI = createApi({
    reducerPath: "userAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getUsers: builder.mutation({
            query: (userQuery) => ({
                url: '/User/GetUsers',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addUser: builder.mutation({
            query: (userDetails) => ({
                url: '/User/AddUser',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            // invalidatesTags: ['User'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateUser: builder.mutation({
            query: (userDetails) => ({
                url: '/User/UpdateUser',
                method: 'POST',
                body: transformRequest(userDetails)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getUserById: builder.query({
            query: (userId) => ({
                url: encryptQueryString(`/User/GetUserById/?id=${Number(userId)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        UpdatePassword: builder.mutation({
            query: (userData) => ({
                url: `/User/UpdatePassword`,
                method: 'POST',
                body: transformRequest(userData)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllRole: builder.mutation({
            query: () => ({
                url: encryptQueryString('/User/getAllRole'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        // get User
        getCandidate: builder.mutation({
            query: (details) => ({
                url: '/Candidate/GetCandidateList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // get User
        getSearchByCandidateName: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetSearchByCandidateName/?searchText=${details}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
})

export const { useGetUsersMutation, useGetAllRoleMutation,
    useAddUserMutation, useLazyGetUserByIdQuery, useUpdatePasswordMutation,
    useUpdateUserMutation, useGetCandidateMutation, useLazyGetSearchByCandidateNameQuery
} = userAPI

export default userAPI;